import axiosClient from './axiosClient';

const unitsApi = {
  create: (data) => {
    const url = '/units';
    return axiosClient.post(url, data);
  },
  get: (params) => {
    const url = '/units/get-units';
    return axiosClient.get(url, { params });
  },
  put: (params, data) => {
    const url = '/units';
    return axiosClient.put(url, data, { params });
  },
  delete: (params) => {
    const url = `/units?id=${params}`;
    return axiosClient.delete(url);
  },
  sortOrder: (params, data) => {
    const url = '/units/sort-units';
    return axiosClient.put(url, data, { params });
  },
  clone: (params) => {
    const url = '/units/clone-unit';
    return axiosClient.post(url, {}, { params });
  },
  quickUpdate: (params, data) => {
    const url = `/units/quick-update?id=${params}`;
    return axiosClient.put(url, data);
  },
  getUnitById: (params) => {
    const url = '/units';
    return axiosClient.get(url, { params });
  },
  addQuestion: (params, data) => {
    const url = '/units/add-question';
    return axiosClient.post(url, data, { params });
  },
  addSurvey: (params, data) => {
    const url = '/units/add-survey';
    return axiosClient.post(url, data, { params });
  },
  removeQuestion: (params) => {
    const url = '/units/remove-question';
    return axiosClient.delete(url, { params });
  },
  removeSurvey: (params) => {
    const url = '/units/remove-survey';
    return axiosClient.delete(url, { params });
  },
  sortQuestionOrder: (params, data) => {
    const url = '/units/sort-questions';
    return axiosClient.put(url, data, { params });
  },
  updateWeight: (params, data) => {
    const url = '/units/update-question-weight';
    return axiosClient.put(url, data, { params });
  },
  getSlideShareInfo: (params) => {
    const url = '/units/get-slideshare-iframe';
    return axiosClient.get(url, { params });
  },
  getTrackingResult: (params) => {
    const url = '/units/get-tracking-result-unit';
    return axiosClient.get(url, { params });
  },
  getSubmissions: (params) => {
    const url = '/units/get-submissions';
    return axiosClient.get(url, { params });
  },
  getSubmission: (params) => {
    const url = '/units/get-submission';
    return axiosClient.get(url, { params });
  },
  gradeSubmission: (params, data) => {
    const url = '/units/grade-submission';
    return axiosClient.post(url, data, { params });
  },
  undoGradeSubmission: (data) => {
    const url = '/units/undo-grade-submission';
    return axiosClient.put(url, data);
  },
  resetSubmission: (id, data) => {
    const url = `units/reset-submission?id=${id}`;
    return axiosClient.post(url, data);
  },
  saveClassrooms: (unitId, data) => {
    const url = `/units/${unitId}/classrooms`;
    return axiosClient.post(url, data);
  },
  liveclassupdateattendance: (id) => {
    const url = `/user-events/${id}/updateAttendance`;
    return axiosClient.get(url);
  },

  // unit lesson drag and drop
  unitLessonDrag: (id, body, type) => {
    const url =
      type !== 'noType'
        ? `/course-units/update-unit-lessons-order/${id}?${type}`
        : `/course-units/update-unit-lessons-order/${id}`;
    return axiosClient.put(url, body);
  },

  // unit drag and drop
  unitGroupDrag: (id, body, type) => {
    const url =
      type === 'unit'
        ? `/course-units/update-units-order-by-group/${id}`
        : `/groups/update-groups-order-by-intake/${id}`;
    return axiosClient.put(url, body);
  },

  //default lesson drag and drop
  defaultLessonDrag: (id, body) => {
    const url = `/units/update-course-default-lessons-order/${id}`;
    return axiosClient.put(url, body);
  },

  updateTrackingFileDelete: (id, body) => {
    const url = `/units/update-user-unit-tracking/${id}`;
    return axiosClient.put(url, body);
  },

  deleteSubmission: (id) => {
    const url = `/units/user-unit-tracking/${id}`;
    return axiosClient.delete(url);
  },

  deleteHistory: (id) => {
    const url = `units/delete-unit-submission-tracking?id=${id}`;
    return axiosClient.delete(url);
  },
  lessonclone: (ids, params) => {
    const url = `units/clone-units`;
    return axiosClient.post(url, ids, { params });
  },
  centreclone: (data) => {
    const url = `units/clone-lessons-to-another-centre`;
    return axiosClient.post(url, data);
  },
  getContent: (params) => {
    const url = `units/get-content-review-units-by-centre`;
    return axiosClient.get(url, { params });
  },
  contentApprove: (data, params) => {
    const url = `/units/update-review-content-status`;
    return axiosClient.put(url, data, { params });
  },

  dateInfo: (data) => {
    const url = '/units/draft-UserUnit';
    return axiosClient.post(url, data);
  },
};

export default unitsApi;
